<div class="modal-header">
  <h5 class="modal-title">{{ "common.add-to-calendar" | translate }}</h5>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body" style="padding: 2rem;">

  <div class="btn-grid">
    <button class="cal-btn btn-google" (click)="openGoogle()">
      <span class="cal-btn__icon" aria-hidden="true">
        <svg width="20" height="20" viewBox="0 0 48 48" focusable="false">
          <path fill="#EA4335" d="M24 9.5c3.7 0 7 1.3 9.6 3.8l7.2-7.2C36.6 2.4 30.7 0 24 0 14.6 0 6.5 5.4 2.6 13.3l8.6 6.7C13 14.3 18 9.5 24 9.5z"/>
          <path fill="#34A853" d="M46.1 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.4c-.5 2.9-2.1 5.4-4.6 7.1l7.1 5.5c4.2-3.8 7.2-9.5 7.2-17.1z"/>
          <path fill="#4A90E2" d="M24 48c6.5 0 12-2.1 16-5.8l-7.1-5.5c-2 1.4-4.6 2.2-7.4 2.2-5.7 0-10.5-3.8-12.2-9l-8.6 6.7C6.5 42.6 14.6 48 24 48z"/>
          <path fill="#FBBC05" d="M11.8 30.9c-.8-2.3-.8-4.9 0-7.2l-8.6-6.7C.9 19.8 0 21.9 0 24c0 2.1.9 4.2 3.2 7.1l8.6-6.7z"/>
        </svg>
      </span>
      <span class="cal-btn__label">{{ "event-calendar.google-calendar" | translate }}</span>
    </button>

    <button
      class="cal-btn btn-outlook cal-btn--accordion"
      (click)="toggleOutlook()"
      (keydown)="onOutlookKeydown($event)"
      [attr.aria-expanded]="outlookOpen"
      aria-controls="outlook-accordion-panel"
    >
      <span class="cal-btn__icon" aria-hidden="true">
        <svg width="20" height="20" viewBox="0 0 48 48" focusable="false">
          <path fill="#0078D4" d="M28 6h14c1.1 0 2 .9 2 2v32c0 1.1-.9 2-2 2H28V6z"/>
          <path fill="#1490DF" d="M6 12h22v24H6z"/>
          <path fill="#fff" d="M19 32c-4.4 0-8-3.6-8-8s3.6-8 8-8c2.2 0 4.2.9 5.7 2.4l-2.2 2.2C21.6 19.6 20.4 19 19 19c-2.8 0-5 2.2-5 5s2.2 5 5 5c1.4 0 2.6-.6 3.5-1.6l2.2 2.2C23.2 31.1 21.2 32 19 32z"/>
        </svg>
      </span>
      <span class="cal-btn__label">Outlook</span>

      <span class="cal-chevron" [class.open]="outlookOpen" aria-hidden="true">
        <svg width="18" height="18" viewBox="0 0 24 24">
          <path fill="currentColor" d="M7 10l5 5 5-5z"/>
        </svg>
      </span>
    </button>

    <div
      id="outlook-accordion-panel"
      class="accordion-panel"
      [class.open]="outlookOpen"
      role="region"
      aria-label="Opciones de Outlook"
      [attr.aria-hidden]="!outlookOpen"
    >
      <button class="cal-subbtn" (click)="openOutlookPersonal()">
        <span class="cal-subbtn__dot" aria-hidden="true"></span>
        <span>{{ "event-calendar.outlook-personal" | translate }}</span>
      </button>

      <button class="cal-subbtn" (click)="openOutlookWork()">
        <span class="cal-subbtn__dot" aria-hidden="true"></span>
        <span>{{ "event-calendar.outlook-work" | translate }}</span>
      </button>
    </div>

    <button class="cal-btn btn-ics" (click)="downloadIcs()" aria-label="Descargar archivo ICS">
      <span class="cal-btn__icon" aria-hidden="true">
        <svg width="20" height="20" viewBox="0 0 24 24" focusable="false">
          <path fill="currentColor" d="M5 20h14v-2H5v2zm7-18l-5 5h3v6h4v-6h3l-5-5z"/>
        </svg>
      </span>
      <span class="cal-btn__label">{{ "common.download-ics" | translate }}</span>
    </button>
  </div>
</div>

